import React from "react";
import styles from "./Fab.module.css";
import Button, {ButtonDesign} from "../Button/Button";
import Icon, {type IconNames, IconSize} from "../Icon/Icon";

interface FabProps {
    onClick?: () => unknown;
    label?: string;
    iconName?: IconNames
}

export const Fab: React.FC<FabProps> = ({onClick, label, iconName}) => {
    return (
        <Button
            fit={!label}
            design={ButtonDesign.primary}
            className={styles.root}
            onClick={onClick}
        >
            {iconName && <Icon name={iconName} size={IconSize.large}/>}
            {label}
        </Button>
    );
};
